import React from 'react';
import { CssBaseline, Grid } from '@mui/material';
import { useStyles } from './LayoutStyle';
import Header from 'components/header/Header';



const Layout = ({ children }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.root}>
      <CssBaseline />

      <Grid container item className={classes.mainBody}>
        <Grid item className={classes.content} md={12}>
            <Header/>
            <div className='heightAlign'>
              {children}
            </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Layout;
